export const roleAdmin = "Admin";
export const roleRead = "Read";
export const roleWrite = "Write";